export const getPageList = (pathname) => [
  {
    path: '/',
    name: '首页',
    active: pathname === '/',
  },
  {
    path: '/blurb',
    name: '关于之阳',
    active: pathname.includes('/blurb'),
  },
  {
    path: '/productCenter',
    name: '产品中心',
    active: pathname.includes('/productCenter'),
  },
  {
    path: '/servicesContent',
    name: '服务内容',
    active: pathname.includes('/servicesContent'),
  },
  {
    path: '/construction',
    name: '实验室建设',
    active: pathname.includes('/construction'),
  },
  {
    path: '/intelligence',
    name: '数智化实验室',
    active: pathname.includes('/intelligence'),
  },
  {
    path: '/news',
    name: '新闻动态',
    active: pathname.includes('/news'),
  },
  {
    path: '/contact',
    name: '联系我们',
    active: pathname.includes('/contact'),
  },
];
